import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  DISCOUNT_CODE_CATEGORY_PATH,
  DISCOUNT_CODE_PATH,
} from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import {
  clearDiscountCodeCategory,
  getDiscountCodeCategory,
  putDiscountCodeCategory,
} from '../../../../actions/sales/DiscountCodeCategory';
import DiscountCodeCategoryForm from './DiscountCodeCategoryForm';

const EditDiscountCodeCategory = ({
  breadcrumbs,
  dispatchGetDiscountCodeCategory,
  dispatchClearDiscountCodeCategory,
  dispatchPutDiscountCodeCategory,
  match: {
    params: { id: discountCodeCategoryId },
  },
  loading,
  discountCode,
}) => {
  useLayoutEffect(() => {
    dispatchGetDiscountCodeCategory({ discountCodeCategoryId });

    return () => dispatchClearDiscountCodeCategory();
  }, []);

  const onSubmit = (values) => {
    const existing = (values.discountCodeSubCategoryList || [])
      .filter((s) => s && s.id != null)
      .map((s) => ({
        id: s.id,
        name: s.name,
        active: !!s.active,
        // 👇 Lista FINAL de autorizadores seleccionados
        discountCodeSubCategoryAuthorizerList: (s.authorizers || []).map(
          (a) => ({
            discountCodeAuthorizerId: a.value,
            active: true,
          }),
        ),
      }));

    const created = (values.newDiscountCodeSubCategoryList || [])
      .filter((s) => s && s.name && s.name.trim())
      .map((s) => ({
        name: s.name,
        active: true,
        discountCodeSubCategoryAuthorizerList: (
          s.discountCodeSubCategoryAuthorizerList || []
        ).map((a) => ({
          discountCodeAuthorizerId: a.value,
          active: true,
        })),
      }));

    const payload = {
      name: values.name,
      description: values.description,
      active: !!values.active,
      discountCodeSubCategoryList: [...existing, ...created],
    };

    dispatchPutDiscountCodeCategory(discountCodeCategoryId, payload);
  };

  const getAuthorizerLabel = (authWrapper = {}) => {
    const auth = authWrapper.discountCodeAuthorizer || {};
    const cust = auth.customer || {};
    return (
      cust.fullName ||
      [cust.firstName, cust.lastName].filter(Boolean).join(' ') ||
      auth.name ||
      `Autorizador ${
        auth.id || authWrapper.discountCodeAuthorizerId || authWrapper.id
      }`
    );
  };

  const generateInitialValues = (discountCodeJson = {}) => ({
    name: discountCodeJson.name,
    description: discountCodeJson.description,
    active: Boolean(discountCodeJson.active),
    discountCodeSubCategoryList: (
      discountCodeJson.discountCodeSubCategoryList || []
    ).map((sc = {}) => ({
      name: sc.name,
      active: Boolean(sc.active),
      id: sc.id,

      authorizers: (sc.discountCodeSubCategoryAuthorizerList || []).map(
        (a) => ({
          value: a.discountCodeAuthorizerId || a.discountCodeAuthorizer.id,
          label: getAuthorizerLabel(a),
        }),
      ),
    })),
  });

  let content;

  if (loading) content = <Loader />;
  else if (discountCode.isEmpty())
    content = <NoDataResource returnPage={DISCOUNT_CODE_PATH} />;
  else
    content = (
      <DiscountCodeCategoryForm
        edit
        onSubmit={onSubmit}
        initialValues={generateInitialValues(discountCode.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Categoría Código de Descuento"
      subtitle="Editar categoría código de descuento"
      content={content}
    />
  );
};

EditDiscountCodeCategory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearDiscountCodeCategory: PropTypes.func.isRequired,
  dispatchGetDiscountCodeCategory: PropTypes.func.isRequired,
  dispatchPutDiscountCodeCategory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  discountCode: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditDiscountCodeCategory.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDiscountCodeCategory: clearDiscountCodeCategory,
  dispatchGetDiscountCodeCategory: getDiscountCodeCategory,
  dispatchPutDiscountCodeCategory: putDiscountCodeCategory,
};

const mapStateToProps = (
  { SalesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría de Códigos de Descuento',
      href: DISCOUNT_CODE_CATEGORY_PATH,
    },
    {
      text: 'Ver',
      href: `${DISCOUNT_CODE_CATEGORY_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  discountCode: SalesUnit.DiscountCodeCategory.getIn(['current', 'content']),
  loading: !SalesUnit.DiscountCodeCategory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDiscountCodeCategory);
